var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "home-footer-info",
      staticStyle: { flex: "none", height: "100%" }
    },
    [
      _c("div", { attrs: { id: "projection" } }, [
        _vm._v(_vm._s(_vm.$tc("Projection", 1)) + ":")
      ]),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: { top: "", "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c("div", _vm._g({ attrs: { id: "projection-data" } }, on), [
                    _vm._v(
                      "\n        " + _vm._s(_vm.projectionLabel) + "\n      "
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            {
              staticClass: "pa-0",
              staticStyle: { "font-size": "10px", "text-align": "start" },
              attrs: { dense: "" }
            },
            _vm._l(_vm.projectionOptions, function(item, index) {
              return _c(
                "v-list-item",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      return _vm.selectProjection(item)
                    }
                  }
                },
                [
                  _c("v-list-item-title", [
                    _vm._v("\n          " + _vm._s(item.label) + "\n        ")
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53bbd6c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53bbd6c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/Projection.vue
// module id = null
// module chunks = 